import { render, staticRenderFns } from "./OfferCreate.vue?vue&type=template&id=8f8f34e2&scoped=true"
import script from "./OfferCreate.vue?vue&type=script&lang=js"
export * from "./OfferCreate.vue?vue&type=script&lang=js"
import style0 from "./OfferCreate.vue?vue&type=style&index=0&id=8f8f34e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8f34e2",
  null
  
)

export default component.exports